import PropTypes from 'prop-types'
import React from 'react'

import { toRoman } from 'helpers'

import { Tooltip } from 'react-wot-bootstrap'

import {
    TOOLTIP_FOOTER,
    TOOLTIP_BACK_FOOTER,
    TOOLTIP_FOOTER_REBUILD,
} from '../../constants.jsx'
import { SORTIE_LEVELS } from 'constants'

import {
    SORTIE_TOOLTIP_TITLE,
    SORTIE_TOOLTIP_SELECTED,
} from './constants.jsx'

import styles from './SortieTooltip.scss'

const SortieTooltip = (props) => {
    return (
        <Tooltip id={props.tooltipId}>
            <div className={styles.content}>
                <h3 className={styles.title}>{SORTIE_TOOLTIP_TITLE(toRoman(SORTIE_LEVELS[props.division]))}</h3>
                {
                    props.isSelected &&
                    <div>
                        <p className={styles.selected}>{SORTIE_TOOLTIP_SELECTED}</p>
                        <div className={styles.divider}/>
                        <p className={styles.footer}>{TOOLTIP_BACK_FOOTER}</p>
                    </div>
                }
                {
                    !props.isSelected &&
                    <p className={styles.footer}>{
                        props.isRebuild ? TOOLTIP_FOOTER_REBUILD : TOOLTIP_FOOTER
                    }</p>
                }
            </div>
        </Tooltip>
    )
}

SortieTooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
    division: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    isRebuild: PropTypes.bool,
}

export default SortieTooltip



// WEBPACK FOOTER //
// ./components/BattleWizard/components/SortieTooltip/SortieTooltip.jsx